import { ActionButton, LinkButton } from '@library/components/buttons';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

interface PageFooterProps {
  isDisabled: boolean;
  isReturnToLastStepAvailable?: boolean;
  onClickPrimary: () => void;
  onClickReturnToLastStep?: () => void;
  onClickSecondary?: () => void;
  primaryButtonText?: string;
  secondaryButtonText?: string;
}

export const PageFooterSteps = ({
  isDisabled,
  isReturnToLastStepAvailable = false,
  onClickPrimary,
  onClickReturnToLastStep = () => {},
  onClickSecondary = undefined,
  primaryButtonText = 'Continue',
  secondaryButtonText = 'Cancel'
}: PageFooterProps) => {
  const returnToLastStepStyling = isReturnToLastStepAvailable
    ? 'justify-between'
    : 'justify-end';
  return (
    <div
      className={`border-soFresh-140 text-soClean-100 flex ${returnToLastStepStyling} border-t px-6 py-4`}
    >
      {isReturnToLastStepAvailable && (
        <LinkButton
          className="justify-self-start"
          label={
            <div className="flex items-center gap-2">
              <ArrowLeftIcon className="size-4" />
              <span>Return to last step</span>
            </div>
          }
          onClick={onClickReturnToLastStep}
        />
      )}
      <div className="flex items-center gap-2">
        {onClickSecondary && (
          <ActionButton
            className="mr-2"
            handleOnClick={onClickSecondary}
            title="Secondary Action"
            variant="secondary"
          >
            {secondaryButtonText}
          </ActionButton>
        )}
        <ActionButton
          disabled={isDisabled}
          handleOnClick={onClickPrimary}
          title="Primary Action"
          variant="primary"
        >
          {primaryButtonText}
        </ActionButton>
      </div>
    </div>
  );
};
